import React, { useState } from 'react';
import { IPostCommentSection } from './interfaces';
import { CardContent } from '@mui/material';
import { MessageInput } from '../../../MessageInput';
import { useTranslation } from 'react-i18next';

export const PostCommentSection: React.FC<IPostCommentSection> = ({
  onCommentPost,
  author,
}): JSX.Element => {
  const { t } = useTranslation();
  const [comment, setComment] = useState<string>('');

  const handleEnter = () => {
    if (comment.length < 10) {
      return;
    }

    onCommentPost(comment);
    setComment('');
  };

  return (
    <CardContent>
      <MessageInput
        author={author}
        placeholder={t('feed:fields.postReaction.placeholder')}
        onChange={setComment}
        value={comment}
        onEnter={handleEnter}
      />
    </CardContent>
  );
};
